<!-- Main view/routes wrapper-->
<router-outlet></router-outlet>

<app-update-banner></app-update-banner>
